/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
import {
  memo,
  forwardRef,
  JSX,
  useEffect,
  useRef,
  isValidElement,
} from 'react';
import DraggableScroller from '@wconcept/wconcept-ui-renewal/components/atoms/DraggableScroller';
import * as S from './style';

interface IProps {
  items?: JSX.Element[];
  isDesktop?: boolean;
}

const EvtNaviType2 = forwardRef<HTMLDivElement, IProps>(
  (props: IProps, ref) => {
    const { items, isDesktop } = props;
    const wrapperRef = useRef<HTMLDivElement>(null);

    const bgColor =
      items?.[0] && isValidElement(items[0])
        ? (items[0].props as { $offBgColor?: string }).$offBgColor
        : undefined;

    useEffect(() => {
      const wrapper = wrapperRef.current;
      if (!wrapper) return;

      // desktop: DraggableScroller의 .draggable-scroller / mobile: .navi-inner
      const scrollEl =
        wrapper.querySelector('.draggable-scroller') ||
        wrapper.querySelector('.navi-inner');
      if (!scrollEl) return;

      requestAnimationFrame(() => {
        const activeItem = scrollEl.querySelector('.active') as HTMLElement;
        if (!activeItem) return;
        const containerRect = scrollEl.getBoundingClientRect();
        const itemRect = activeItem.getBoundingClientRect();
        scrollEl.scrollLeft =
          scrollEl.scrollLeft +
          itemRect.left -
          containerRect.left -
          (containerRect.width - itemRect.width) / 2;
      });

      const handleWheel = (e: Event) => {
        const { deltaX, deltaY } = e as WheelEvent;
        e.preventDefault();
        scrollEl.scrollLeft += deltaX !== 0 ? deltaX : deltaY;
      };
      scrollEl.addEventListener('wheel', handleWheel, { passive: false });
      // eslint-disable-next-line consistent-return
      return () => scrollEl.removeEventListener('wheel', handleWheel);
    }, [items]);

    return (
      <S.EvtNaviType2
        ref={ref}
        className="event-navigation-type2"
        $bgColor={bgColor}
      >
        <div ref={wrapperRef}>
          {isDesktop ? (
            <DraggableScroller className="navi-inner">
              {items}
            </DraggableScroller>
          ) : (
            <div className="navi-inner">{items}</div>
          )}
        </div>
      </S.EvtNaviType2>
    );
  }
);

export default memo(EvtNaviType2);
